import axios from 'axios';

export default axios.create({
  baseURL: '/app/api/tabulados/pxwebv2/api'

})